import Lara from '@primeng/themes/lara';
import {definePreset} from '@primeng/themes';

import base from './base';
import button from './button';

///
/// More information about theming at https://primeng.org/theming
///

export const AxxerTheme = definePreset(Lara, {
  ...base,
  components: {
    button: button
  },

})
